import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../axios";

function UserEdit() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    userState: "",
    qualification: "",
    planName: "",
    amount: ""
  });
  const [currentRemaining, setCurrentRemaining] = useState(0);
const [deductAmount, setDeductAmount] = useState("");
const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      const res = await axios.get(`getSingleUserDetail/${id}`);
      const user = res?.data?.result;

      setFormData({
        name: user?.name || "",
        email: user?.email || "",
        mobile: user?.mobile || "",
        userState: user?.userState || "",
        qualification: user?.qualification || "",
        planName: user?.planName || "",
        amount: user?.amount || "",
      });
      setCurrentRemaining(user?.remaining || 0);

    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(`userUpdate/${id}`, formData);

      alert("User Updated Successfully");

      navigate("/dash/active-user");

    } catch (error) {
      console.log(error);
      alert("Error updating user");
    }
  };

  const handleReduceRemaining = async () => {
  if (!deductAmount || Number(deductAmount) <= 0) {
    return alert("Enter valid amount");
  }

  try {
    setLoading(true);

    const res = await axios.put(`/updateRemainingAmount/${id}`, {
      userId: id,
      deductAmount,
    });

    alert(res.data.message);

    setCurrentRemaining(res.data.result.remaining);
    setDeductAmount("");

    fetchUser();
  } catch (error) {
    alert(
      error?.response?.data?.message ||
      "Failed to reduce remaining amount"
    );
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="p-10 bg-gray-100 min-h-screen">

      <div className="max-w-3xl mx-auto bg-white p-8 shadow-lg rounded-lg">

        <h2 className="text-2xl font-bold mb-6 text-purple">
          Edit User
        </h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">

          <div>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>Email</label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>Mobile</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>State</label>
            <input
              type="text"
              name="userState"
              value={formData.userState}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>Qualification</label>
            <input
              type="text"
              name="qualification"
              value={formData.qualification}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>Plan Name</label>
            <input
              type="text"
              name="planName"
              value={formData.planName}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div>
            <label>Amount Paid</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            />
          </div>

          <div className="col-span-2 mt-4">
            <button
              type="submit"
              className="bg-purple text-white px-6 py-2 rounded"
            >
              Update User
            </button>
          </div>

        </form>

<div className="mt-8 border rounded-lg p-6 bg-gray-50">
  <h3 className="text-xl font-semibold mb-4 text-red-600">
    Reduce Remaining Amount
  </h3>

  <div className="mb-4">
    <label className="font-medium">Current Remaining</label>
    <input
      type="number"
      value={currentRemaining}
      disabled
      className="border p-2 w-full rounded bg-gray-100"
    />
  </div>

  <div className="mb-4">
    <label className="font-medium">Deduct Amount (₹)</label>
    <input
      type="number"
      value={deductAmount}
      onChange={(e) => setDeductAmount(e.target.value)}
      className="border p-2 w-full rounded"
      placeholder="Enter amount"
    />
  </div>

  <button
    type="button"
    disabled={loading}
    onClick={handleReduceRemaining}
    className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded"
  >
    {loading ? "Updating..." : "Reduce Remaining"}
  </button>
</div>
      </div>

    </div>
  );
}

export default UserEdit;